import React from "react";
import AllDashboard from "./Dashboard/AllDashboard";
import { Button, NewTab, PageTabAdv } from "../../../components";
import { useEffect } from "react";
import { getTotalCountsOnboarding } from "../../../redux/slices/onboarding/onboardingApi";
import { useState } from "react";
import { useLocation } from "react-router-dom";

const Dashboard = () => {
  const location = useLocation();
  const [allTotalCounts, setAllTotalCounts] = useState(null);
  const [entityFilter,setEntityFilter] = useState(location?.state?.entityFromInitiate || 1)
  useEffect(() => {
    const fetchOnboardingTotalCounts = async () => {
      try {
        const statuses = [null, 2, 3, 4, 5, 6, 7, 8, 9];

        const requests = statuses.map((value) =>
          getTotalCountsOnboarding({
            filters: value
              ? {
                  "entity.type": {
                    type: "NONE",
                    value: entityFilter,
                  },
                  status: { type: "NONE", value },
                }
              : {
                  "entity.type": {
                    type: "NONE",
                    value: entityFilter,
                  },
                },
          })
        );

        const results = await Promise.all(requests);

        const mapped = statuses.reduce((acc, value, i) => {
          acc[value ?? "all"] = results[i];
          return acc;
        }, {});

        setAllTotalCounts(mapped);
      } catch (err) {
        console.error("Failed fetchOnboardingTotalCounts", err);
      }
    };

    fetchOnboardingTotalCounts();
  }, [entityFilter]);

  //  const DashboardTabMenus = [
  //     {
  //       title: "Applicant",
  //       type: "main",
  //      onClick: () => setEntityFilter(1),

  //     },

  //     {
  //       title: "Vendor",
  //       type: "main",
  //       onClick:()=>setEntityFilter(2),
  //     },

  //     {
  //       title: "Client",
  //       type: "main",
  //      onClick:()=>setEntityFilter(3),
  //     },

  //   ];

  const DashboardMenus = [
    {
      title: "All",
      page: (
        <AllDashboard
          statusFilter={null}
          entityFilter={entityFilter}
          pageName="All"
          onDropdownClick={(page, btn) =>
            console.log("Clicked in:", page, "Button:", btn)
          }
        />
      ),
      type: "main",
      value: allTotalCounts?.all?.totalCount?.data || 0,
    },
    {
      title: "Draft",
      page: (
        <AllDashboard
          statusFilter={2}
          entityFilter={entityFilter}
          pageName="Draft"
          onDropdownClick={(page, btn) =>
            console.log("Clicked in ", page, "Tab", btn)
          }
        />
      ),
      // page: <Draft />,
      type: "main",
      value: allTotalCounts?.[2]?.totalCount?.data || 0,
    },
    {
      title: "Initiated",
      page: (
        <AllDashboard
          statusFilter={3}
          entityFilter={entityFilter}
          pageName="Initiated"
          onDropdownClick={(page, btn) =>
            console.log("Clicked in", page, "Tab", btn, "button.")
          }
        />
      ),
      // page: <Initiated />,
      type: "main",
      value: allTotalCounts?.[3]?.totalCount?.data || 0,
    },
    {
      title: "Responded",
      page: (
        <AllDashboard
          statusFilter={4}
          entityFilter={entityFilter}
          pageName="Responded"
          onDropdownClick={(page, btn) =>
            console.log("Clicked in ", page, "Tab", btn)
          }
        />
      ),
      // page: <Responded />,
      type: "main",
      value: allTotalCounts?.[4]?.totalCount?.data || 0,
    },
    {
      title: "Verified",
      page: (
        <AllDashboard
          statusFilter={5}
          entityFilter={entityFilter}
          pageName="Verified"
          onDropdownClick={(page, btn) =>
            console.log("Clicked in ", page, "Tab", btn)
          }
        />
      ),
      // page: <Verified />,
      type: "main",
      value: allTotalCounts?.[5]?.totalCount?.data || 0,
    },
    {
      title: "Negotiate",
      page: (
        <AllDashboard
          statusFilter={6}
          entityFilter={entityFilter}
          pageName="Negotiate"
          onDropdownClick={(page, btn) =>
            console.log("Clicked in ", page, "Tab", btn)
          }
        />
      ),
      // page: <Negotiate />,
      type: "main",
      value: allTotalCounts?.[6]?.totalCount?.data || 0,
    },
    {
      title: "Joined",
      page: (
        <AllDashboard
          statusFilter={7}
          entityFilter={entityFilter}
          pageName="Joined"
          onDropdownClick={(page, btn) =>
            console.log("Clicked in ", page, "Tab", btn)
          }
        />
      ),
      // page: <Joined />,
      type: "main",
      value: allTotalCounts?.[7]?.totalCount?.data || 0,
    },
    {
      title: "Disqulified",
      page: (
        <AllDashboard
          statusFilter={8}
          entityFilter={entityFilter}
          pageName="Disqualified"
          onDropdownClick={(page, btn) =>
            console.log("Clicked in ", page, "Tab", btn)
          }
        />
      ),
      // page: <Disqulified />,
      type: "main",
      value: allTotalCounts?.[8]?.totalCount?.data || 0,
    },
    {
      title: "Cancelled",
      page: (
        <AllDashboard
          statusFilter={9}
          entityFilter={entityFilter}
          pageName="Cancelled"
          onDropdownClick={(page, btn) =>
            console.log("Clicked in ", page, "Tab", btn)
          }
        />
      ),
      // page: <Cancelled />,
      type: "main",
      value: allTotalCounts?.[9]?.totalCount?.data || 0,
    },
  ];
  return (
    <div className="mt-5">
      <div className="flex gap-0 min-w-[320px] justify-end">
        <Button
          title="Applicant"
          variant={entityFilter === 1 ? "contained" : "outlined"}
          className="rounded-none"
          onClick={() => {
            setEntityFilter(1);
          }}
        />
        <Button
          title="Vendor"
          variant={entityFilter === 2 ? "contained" : "outlined"}
          className="rounded-none border-x-0"
          onClick={() => {
            setEntityFilter(2);
          }}
        />
        <Button
          title="Client"
          variant={entityFilter === 3 ? "contained" : "outlined"}
          className="rounded-none"
          onClick={() => {
            setEntityFilter(3);
          }}
        />
      </div>
      {/* <NewTab 
      tabs={DashboardTabMenus}
      color="black"
      variant="outlined"
      
      // mode="url"
      // tabId="e-onboarding"
      /> */}
      <div className="mt-5">
        <NewTab
          tabs={DashboardMenus}
          color="black"
          variant="text"
          activeVariant="text"
          mode="url"
          tabId="e-onboarding-dashboard"
        />
      </div>
    </div>
  );
};

export default Dashboard;
